import { Fragment, useMemo } from "react";
import { Container, Table } from "react-bootstrap";
import Laoding from "../components/Loading";
import usePackage from "../hooks/usePackage";
import usePage from "../hooks/usePage";
import Footer from "../modules/public/footer/footer";
import Menu from "../modules/public/menu/menu";
import styles from "./ContentBox.module.css";

const ContentBox = () => {
  const { pageSliders, pageImage, pageText } = usePage();
  const { isFetching, packages } = usePackage();

  const packagesList = useMemo(() => {
    if (!packages) return [];

    const list = [
      { name: "کارتن", type: 1 },
      { name: "پاکت", type: 6 },
      { name: "پاکت حبابدار", type: 3 },
      { name: "پاکت فلایر", type: 8 },
      { name: "کیسه", type: 2 },
    ];

    for (const item of list) {
      item.items = packages.filter(element => element.type === item.type);
    }

    return list;
  }, [isFetching]);

  console.log("a", packagesList);

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}

        <Container className="py-5 rtl-all">
          <h4 className="mb-0">لیست قیمت های بسته بندی</h4>
          <p>قیمت های زیر با احتساب کارمزد بسته بندی و چسب می‌باشد.</p>

          {isFetching && <Laoding />}

          {!isFetching &&
            packagesList.map(packageType => (
              <div key={packageType.type} className="py-2 overflow-x-auto">
                <h5>{packageType.name}</h5>
                <Table striped bordered hover className={styles.table}>
                  <thead>
                    <tr>
                      <th style={{ width: 75 }}>ردیف</th>
                      <th style={{ width: 300 }}>نوع بسته بندی</th>
                      <th style={{ width: 300 }}>ابعاد</th>
                      <th style={{ minWidth: 100 }}>قیمت</th>
                    </tr>
                  </thead>
                  <tbody>
                    {packageType.items.map((item, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{item.name}</td>
                        <td>
                          <span>{item.length}</span>
                          <span> × </span>
                          <span>{item.width}</span>
                          <span> × </span>
                          <span>{item.height}</span>
                        </td>
                        <td className={styles.priceTD}>
                          <span>{Number(item.price).toLocaleString()}</span>
                          <span> ریال</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ))}

          {pageText}
        </Container>

        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default ContentBox;
